import { render, staticRenderFns } from "./MarketDepth.vue?vue&type=template&id=2191362f&"
import script from "./MarketDepth.vue?vue&type=script&lang=js&"
export * from "./MarketDepth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports